<script setup lang="ts">
import { BaseAvatar, BaseDropdownActionList } from '@cplug/design-system/components'
import { AvatarSize } from '@cplug/design-system/components/props'
import AppVersionInfoDialog from '~/shared/components/molecules/AppVersionInfoDialog.vue'
import { useSidebarUserMenu } from '~/domain/shared/navigation/composables/useSidebarUserMenu'

withDefaults(defineProps<{
  avatarSize?: AvatarSize
}>(), {
  avatarSize: AvatarSize.Small
})

const {
  loggedUser,
  onClickUser,
  onUserMenuClick,
  t,
  user,
  userMenu,
  userMenuItems,
  versionInfoDialogOpen
} = useSidebarUserMenu()
</script>

<template>
  <div class="sidebar-user-menu relative flex items-center justify-center">
    <div
      data-testid="user-avatar"
      class="cursor-pointer"
      @click="onClickUser"
    >
      <BaseAvatar
        :label="user?.name"
        :size="avatarSize"
        shape="circle"
      />
    </div>

    <BaseDropdownActionList
      ref="userMenu"
      data-testid="user-menu-dropdown"
      :options="userMenuItems"
      @click="onUserMenuClick"
    >
      <template #header>
        <div
          class="border-b border-border p-3"
          data-testid="user-menu"
        >
          <div class="flex items-center gap-3">
            <BaseAvatar
              :label="user?.name"
              :size="AvatarSize.Medium"
              shape="circle"
            />
            <div>
              <div
                class="text-sm font-semibold text-foreground"
                data-testid="user-name"
              >
                {{ user?.name }}
              </div>
              <div
                class="text-xs text-muted-foreground"
                data-testid="user-role"
              >
                {{ loggedUser?.permissionGroup?.name ?? t('User') }}
              </div>
            </div>
          </div>
        </div>
      </template>
    </BaseDropdownActionList>

    <AppVersionInfoDialog v-model="versionInfoDialogOpen" />
  </div>
</template>
